<template>
<div class="container" id='app' v-cloak>
    <div class="row align-items-start">

        <div class="col-3" style="height: 80vh; overflow: auto;">
            <!-- zone Show address -->
            <!-- <p>{{ $route.params.address }}</p> -->
            <Address
              :address="from"
              label="from"
              @edit="addressToEdit = from"
              @search="fetchCoordinates(from)"
            />
            <hr>
             <Address
              :address="to"
              label="to"
              @edit="addressToEdit = to"
              @search="fetchCoordinates(to)"
            />
            <hr>
            <!-- zone Edit address -->
            <div class="change-zone">
                <div v-if="!addressToEdit">No data available.</div>
                
                <!-- Table of addresses  -->
                <div v-else-if="addressToEdit === 'info'">
                  <ul class="list-group list-group-flush" v-if="!loading">
                    <i> Found ( {{ coordinates.length }} ) addresses :</i>
                    <li 
                      class="list-group-item" 
                      v-for="coordinate in coordinates" 
                      :key="coordinate.id"
                      @mouseover="currentCoordinate = coordinate"
                    >
                    {{ coordinate.properties.label }} <br>
                    {{ coordinate.properties.context }} <br>
                    <button class="btn btn-danger" @click="currentCoordinate = coordinate">GO</button>
                    </li>
                  </ul>
                  <div v-else>
                    <button class="btn btn-primary" type="button" disabled>
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Loading...
                    </button>
                  </div>
                </div>

                <AddressForm
                  v-else-if="addressToEdit"
                  :addressToEdit="addressToEdit"
                  :fields="fields"
                  @close="addressToEdit = null"
                />
              </div>
        </div>

        <div class="col-sm-9">
          <br>

          <MyMap 
            :coordinates = "coordinates"
            :currentCoordinate = "currentCoordinate"
          >
          <template v-if="currentCoordinate" v-slot:popup>
              {{ currentCoordinate.properties.label }}
            </template>
          </MyMap>
        </div>
    </div>
</div>
</template>

<script>
import Address from '@/components/Address.vue'
import AddressForm from '@/components/AddressForm.vue'
import MyMap from '@/components/Map.vue'
import { store } from '@/store/index.js'

export default {
  components: { 
    Address, 
    AddressForm, 
    MyMap 
  },
  props: {
    address: {
      type: String
    }
  },
  data () {
    // const addressJSON = JSON.parse(this.$route.params.address || '{}')
    return store.state
  },
  methods: {
    fetchCoordinates: store.fetchCoordinates

    // async fetchCoordinates (address) {
    //   this.loading = true
    //   this.addressToEdit = 'info'
    //   // console.log('loading... :', this.loading)
    //   // try {
    //     const response = await fetch(
    //       'https://api-adresse.data.gouv.fr/search/?q=' +
    //       address.road + ' ' + address.zipCode + ' ' + address.city + ' '
    //     )

    //     const json = await response.json()
    //     json.features.forEach(currentFeature => {
    //       currentFeature.geometry.coordinates.reverse()
    //     })
    //     this.coordinates = json.features
    //   // } catch {
    //   //   // do nothing
    //   // }
    //   this.loading = false
    // }
  }
}

</script>


